'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _NodeContainer = require('./NodeContainer');

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _position = require('./parsing/position');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var StackingContext = function () {
  function StackingContext(container, parent, treatAsRealStackingContext) {
    _classCallCheck(this, StackingContext);

    this.container = container;
    this.parent = parent;
    this.contexts = [];
    this.children = [];
    this.treatAsRealStackingContext = treatAsRealStackingContext;
  }

  _createClass(StackingContext, [{
    key: 'getOpacity',
    value: function getOpacity() {
      return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
    }
  }, {
    key: 'getRealParentStackingContext',
    value: function getRealParentStackingContext() {
      return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
    }
  }]);

  return StackingContext;
}();

exports.default = StackingContext;